module.exports = __webpack_public_path__ + "img/PRNT_03_mono_AE_00004.b75f7803.png";